import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    html, * {
        font-family: "Roboto", sans-serif;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    html, body {
        height: 100%;
        margin: 0;
        padding: 0;
        background-color: ${({ theme }) => theme.colors.bgWhite};
    }

    #root {
        height: 100%;
    }
`;

export default GlobalStyle;
